import Vue from 'vue'
import Router from 'vue-router'
const AppShell = () => import('@/components/AppShell')
const Login = () => import('@/components/auth/Login')
const Register = () => import('@/components/auth/Register')
const ChangePassword = () => import('@/components/auth/changePassword')

const SurveyList = () => import('@/components/SurveyList')
const SurveyPreview = () => import('@/components/survey/SurveyPreview')
const SurveySaveUpdate = () => import('@/components/survey/SurveySaveUpdate')
const Questions = () => import('@/components/survey/Questions')
const ResponseList = () => import('@/components/response/ResponseList')
const NewResponse = () => import('@/components/response/ResponseSaveUpdate')
const Profile = () => import('@/components/user/UserProfile')

const Body = () => import('@/components/body')
const SiswaBody = () => import('@/components/siswabody')
const Dashboard = () => import('@/pages/dashboard')
const FormBaseInputs = () => import('@/pages/forms/form_base_inputs')
const MasterKelas = () => import('@/pages/master/master_kelas')
const MasterSiswa = () => import('@/pages/master/master_siswa')
const MasterMatapel = () => import('@/pages/master/master_matapel')
const MasterWalikelas = () => import('@/pages/master/master_walikelas')
const MasterGuru = () => import('@/pages/master/master_guru')
const MasterPeriode = () => import('@/pages/master/master_periode')
const TableSmartTable = () => import('@/pages/tables/vuejs_smart_table/basic')
const Topik = () => import('@/pages/banksoal/topik')
const Soal = () => import('@/pages/banksoal/soal')
const JawabanSoalPg = () => import('@/pages/banksoal/addjawabanpg')
const ImportSoal = () => import('@/pages/banksoal/importsoal')
const Ujian = () => import('@/pages/ujian/ujian')
const EvaluasiUjian = () => import('@/pages/ujian/evaluasi_ujian')
const FixJawaban = () => import('@/pages/ujian/fix_jawaban')

const PlotWalikelas = () => import('@/pages/plot/plot_walikelas')
const PlotSiswa = () => import('@/pages/plot/plot_siswa')
const PlotGuru = () => import('@/pages/plot/plot_guru')

const DashboardSiswa = () => import('@/pages/siswa/dashboard')
const JawabSoal = () => import('@/pages/siswa/jawabsoal')
const JawabSoalPentashi = () => import('@/pages/siswa/jawabsoalpentashi')
const ShowPdf = () => import('@/pages/siswa/showpdf')

Vue.use(Router)

export default new Router({
    mode: "history",
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/login',
            name: 'Security',
            component: {
                render(c) { return c('router-view') }
            },
            children: [
                {
                    path: '/login',
                    name: 'Login',
                    component: Login,
                    meta: { title: 'Login' }
                },
                {
                    path: '/loginadmin',
                    name: 'LoginAdmin',
                    component: Login,
                    meta: { title: 'Login Admin' }
                },
                {
                    path: '/register',
                    name: 'Register',
                    component: Register,
                    meta: { title: 'Register' }
                },
            ]
        },
        {
            path: '/auth',
            component: ChangePassword,
            children: [
                {
                    path: 'change-password',
                    name: 'ChangePassword',
                    component: ChangePassword,
                    meta: {
                        title: 'Change Password | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","WALIKELAS","GURU","SISWA","OPERATOR","PENTASHI"]
                    }
                },
            ]            
        },
        {
            path: '',
            redirect: '/master/dashboard',
            component: Body            
        },        
        {
            path: '/master',
            component: Body,
            children: [
                {
                    path: 'dashboard',
                    name: 'Dashboard',
                    component: Dashboard,
                    meta: {
                        title: 'Dashboard | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","WALIKELAS","GURU","OPERATOR","PENTASHI"]
                    }
                },
                {
                    path: 'kelas',
                    name: 'MasterKelas',
                    component: MasterKelas,
                    meta: {
                        title: 'Master Kelas | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","WALIKELAS","GURU"]
                    }
                },
                {
                    path: 'siswa',
                    name: 'MasterSiswa',
                    component: MasterSiswa,
                    meta: {
                        title: 'Master Siswa | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","WALIKELAS","GURU"]
                    }
                },
                {
                    path: 'matapel',
                    name: 'MasterMatapel',
                    component: MasterMatapel,
                    meta: {
                        title: 'Master Matapelajaran | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","WALIKELAS","GURU"]
                    }
                },
                {
                    path: 'walikelas',
                    name: 'MasterWalikelas',
                    component: MasterWalikelas,
                    meta: {
                        title: 'Master Walikelas | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","WALIKELAS","GURU"]
                    }
                },   
                {
                    path: 'guru',
                    name: 'MasterGuru',
                    component: MasterGuru,
                    meta: {
                        title: 'Master Guru | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","WALIKELAS","GURU"]
                    }
                },
                {             
                    path: 'periode',
                    name: 'MasterPeriode',
                    component: MasterPeriode,
                    meta: {
                        title: 'Master Periode | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","WALIKELAS","GURU"]
                    }
                },                
            ]
        },
        {
            path: '/dashboardsiswa',
            component: SiswaBody,
            children: [
                {
                    path: 'dashboard',
                    name: 'DashboardSiswa',
                    component: DashboardSiswa,
                    meta: {
                        title: 'Dashboard Siswa| CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["SISWA"]
                    }
                },
                {
                    path: 'jawabsoal/:idtest',
                    name: 'JawabSoal',
                    component: JawabSoal,
                    meta: {
                        title: 'Sesi Tes | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["SISWA"]
                    }
                },                
                {
                    path: 'showpdf',
                    name: 'ShowPdf',
                    component: ShowPdf,
                    meta: {
                        title: 'Page Pdf | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["SISWA"]
                    }
                },
                {
                    path: 'jawabsoalpentashi/:idtest',
                    name: 'JawabSoalPentashi',
                    component: JawabSoalPentashi,
                    meta: {
                        title: 'Sesi Tes | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","PENTASHI","OPERATOR"]
                    }
                }
            ]
        },
        {
            path: '/plot',
            component: Body,
            children: [
                {
                    path: 'walikelas',
                    name: 'PlotWalikelas',
                    component: PlotWalikelas,
                    meta: {
                        title: 'Plot Walikelas | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","WALIKELAS","GURU"]
                    }
                },
                {
                    path: 'siswa',
                    name: 'PlotSiswa',
                    component: PlotSiswa,
                    meta: {
                        title: 'Plot Siswa | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","WALIKELAS","GURU"]
                    }
                },
                {
                    path: 'guru',
                    name: 'PlotGuru',
                    component: PlotGuru,
                    meta: {
                        title: 'Plot Guru | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","WALIKELAS","GURU"]
                    }
                }                         
            ]
        },
        {
            path: '/banksoal',
            component: Body,
            children: [
                {
                    path: 'topik',
                    name: 'Topik',
                    component: Topik,
                    meta: {
                        title: 'Topik | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","OPERATOR"]
                    }
                },
                {
                    path: 'soal',
                    name: 'Soal',
                    component: Soal,
                    meta: {
                        title: 'Soal | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","OPERATOR"]
                    }
                },
                {
                    path: 'jawabanpg/:idsoal',
                    name: 'JawabanSoalPg',
                    component: JawabanSoalPg,
                    meta: {
                        title: 'Soal | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","OPERATOR"]
                    }
                },
                {
                    path: 'importsoal',
                    name: 'ImportSoal',
                    component: ImportSoal,
                    meta: {
                        title: 'Import Soal | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","OPERATOR"]
                    }
                },                
            ]
        },
        {
            path: '/ujian',
            component: Body,
            children: [
                {
                    path: 'ujian',
                    name: 'Ujian',
                    component: Ujian,
                    meta: {
                        title: 'Topik | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","WALIKELAS","GURU","OPERATOR","PENTASHI"]
                    }
                },                 
                {
                    path: 'evaluasi-ujian',
                    name: 'EvaluasiUjian',
                    component:  EvaluasiUjian,
                    meta: {
                        title: 'Evaluasi Ujian | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN","WALIKELAS","GURU","OPERATOR"]
                    }
                },
                {
                    path: 'fix-jawaban',
                    name: 'FixJawaban',
                    component:  FixJawaban,
                    meta: {
                        title: 'Fixing Jawaban | CBT Darunnajah',
                        requriesAuth: true,
                        authorize: ["ADMIN"]
                    }
                }                       
            ]
        },
        {
            path: '/table',
            component: Body,
            children: [
                {
                    path: 'smarttable',
                    name: 'TableSmartTable',
                    component: TableSmartTable,
                    meta: {
                        title: 'Smart Table | CBT Darunnajah',
                        requriesAuth: true
                    }
                },                
            ]
        },
        {
            path: '/xxx',
            redirect: '/dashboard2',
            name: 'AppShell',
            component: AppShell,
            children: [
                {
                    path: '/dashboard2',
                    name: 'Dashboard 2',
                    component: Dashboard,
                    meta: { title: 'Dashboard 2', requriesAuth: true, authorize: ["ADMIN","WALIKELAS","GURU"]}
                },
                {
                    path: '/new-survey',
                    name: 'New Survey',
                    component: SurveySaveUpdate,
                    meta: { title: 'New Survey', requriesAuth: true, authorize: ["ADMIN","WALIKELAS","GURU"]}
                },
                {
                    path: '/survey-preview/:survey',
                    name: 'Survey Preview',
                    component: SurveyPreview,
                    meta: { title: 'Survey Preview', requriesAuth: true }
                },                
                {
                    path: '/questions/:survey',
                    name: 'Questions',
                    component: Questions,
                    meta: { title: 'Questions', requriesAuth: true, authorize: ["ADMIN","WALIKELAS","GURU"]}
                },
                {
                    path: '/responses/:survey',
                    name: 'Response List',
                    component: ResponseList,
                    meta: { title: 'Response List', requriesAuth: true }
                }, 
                {
                    path: '/survey-list-response',
                    name: 'Survey List',
                    component: SurveyList,
                    meta: { title: 'Survey List', requriesAuth: false }
                },
                {
                    path: '/create-response/:survey',
                    name: 'New Response',
                    component: NewResponse,
                    meta: { title: 'New Response', requriesAuth: false }
                }, 
                {
                    path: '/profile',
                    name: 'Profile',
                    component: Profile,
                    meta: { title: 'Profile', requriesAuth: true }
                }, 
            ]
        },
        {
            path: '/form',
            component: Body,
            children: [
                {
                path: 'inputs',
                name: 'FormBaseInputs',
                component: FormBaseInputs,
                meta: {
                    title: 'FormBaseInputs | Cuba - Premium Admin Template',
                    }
                },
            ]
        }
    ],
})

